module.exports = "<div class=\"hint\">\n يجب ان يكون الرابط من youtub\n</div>\n"